import { Card, Heading, Link, Paragraph } from '@digdir/designsystemet-react';
import { ReactNode } from 'react';
import { LanguageTag } from '@/components/language-tag';
import { localization, SupportedLanguage } from '@/libs/language';
import { formatLanguages } from '@/utils/functions';
import styles from './search-hit.module.css';

interface SearchHitProps {
  title?: string;
  href?: string;
  description?: string;
  tagsList?: ReactNode;
  fallbackLanguage?: SupportedLanguage;
}

const SearchHit = ({ title, href, description, tagsList, fallbackLanguage }: SearchHitProps) => {
  return (
    <Card aria-label={title} role='article'>
      {fallbackLanguage && (
        <div className={styles.hasNotValueInSelectedLanguage}>
          <LanguageTag
            tooltipContent={localization.classification.language.notSelectedLanguage}
            title={formatLanguages(fallbackLanguage)}
          />
        </div>
      )}
      {href && title ? (
        <Heading data-size='md' className={styles.headingLink} level={2}>
          <Link href={href}>
            {title && (
              <span className='primaryHeading' {...(fallbackLanguage ? { lang: fallbackLanguage } : {})}>
                {title}
              </span>
            )}
          </Link>
        </Heading>
      ) : undefined}

      {description && (
        <Paragraph
          className={`${styles.truncateTo3Lines} ingress`}
          {...(fallbackLanguage ? { lang: fallbackLanguage } : {})}
        >
          {description}
        </Paragraph>
      )}

      {tagsList && <div className={styles.tagsList}>{tagsList}</div>}
    </Card>
  );
};

export { SearchHit };
